export default __webpack_public_path__ + "static/media/caio-game.ad48ee72.png";